import {useMemo} from 'react';
import {useMutation, useQuery, useQueryClient} from 'react-query';
import QuestionnaireApiService from '@/modules/templates/services/QuestionnaireApiService';
import useAlerts from '@/hooks/useAlerts';

export const useGetQuestionnaire = (questionnaireId) => {
  const queryConfig = useMemo(() => {
    return {enabled: !!questionnaireId};
  }, [questionnaireId]);

  return useQuery(['get-one-questionnaire'], async () => {
    const {data} = await QuestionnaireApiService.getOne({questionnaireId});
    return data;
  }, queryConfig);
};

export const useCrudImagesQuestionnaire = () => {
  const queryClient = useQueryClient();
  const {putErrorCode} = useAlerts();

  const {mutateAsync: create, isLoading: isCreating} = useMutation(QuestionnaireApiService.manageEvidence,
    {
      onSuccess: (id) => {
        queryClient.invalidateQueries([id]);
      },
      onError: (e) => {
        putErrorCode(e);
      }
    });

  return {
    create,
    isCreating,
    isLoading: isCreating
  };
};
